import React, { Suspense } from 'react';

import LoadingScreen from '../Elements/LoadingScreen';

const SuspenseWithLoading = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
);

export default SuspenseWithLoading;
